
export const encapsulatorPropName = "i";

export function encapsulateItem(item: any): { [key: string]: any } {
    if (!item[encapsulatorPropName]) {
        return { [encapsulatorPropName]: item }
    }
    return item
}

export function encapsulateItems(items: any[]) {
    return items.map((i: any) => encapsulateItem(i))
}

export function isEncapsulated(items: any | any[]): boolean {
    let item: any;
    if (Array.isArray(items)) {
        item = items[0]
    } else {
        item = items
    }
    return item[encapsulatorPropName] ? true : false
}

export function unEncapsulate(possiblyEncapsulated: any) {
    return possiblyEncapsulated[encapsulatorPropName] || possiblyEncapsulated
}

export function unEncapsulateItems(items: any[]) {
    return items.map((i: any) => unEncapsulate(i))
}

